
import {
    activeMainAdminApi,
    createSubAdminApi,
    createSubAdminListApi,
    deleteMainAdminApi,
    editAdminApi,
    getAccessListApi,
    uploadAvatarApi
} from '../Api/api';
import {
    activeMainAdminLoad,
    activeMainAdminSuccess,
    createSubAdminFail,
    createSubAdminListFail,
    createSubAdminListLoad,
    createSubAdminListSuccess,
    createSubAdminLoad,
    createSubAdminSuccess,
    deleteMainAdminLoad,
    deleteMainAdminSuccess,
    editAdminLoad,
    editAdminSuccess,
    getAccessListFail,
    getAccessListLoad,
    getAccessListSuccess,
    uploadAvatarLoad,
    uploadAvatarSuccess
} from '../slices/setting.slice';

import appconstant from '../../themes/appconstant';
import { put, call, takeLatest } from "@redux-saga/core/effects";
import { toast } from "react-toastify";


function* createSubAdminSaga(action) {
    try {
        const data = yield call(createSubAdminApi, action.payload);
        if (data.status === 0) {
            toast.success(data?.result?.message);
            yield put(createSubAdminSuccess(data.result.data));
        } else {
            toast.error(data?.result?.message);
            yield put(createSubAdminFail());
        }
    } catch (e) {
        toast.error(appconstant.serverError);
        yield put(createSubAdminFail());
    }
}

function* createSubAdminListSaga(action) {
    try {
        const data = yield call(createSubAdminListApi, action.payload);
        if (data.status === 0) {
            yield put(createSubAdminListSuccess(data.result.data));
        } else {
            toast.error(data?.result?.message);
            yield put(createSubAdminListFail());
        }
    } catch (e) {
        toast.error(appconstant.serverError);
        yield put(createSubAdminListFail());
    }
}

function* getAccessListSaga(action) {
    try {
        const data = yield call(getAccessListApi, action.payload);
        if (data.status === 0) {
            yield put(getAccessListSuccess(data.result.data));
        } else {
            yield put(getAccessListFail());
        }
    } catch (e) {
        toast.error(appconstant.serverError);
        yield put(getAccessListFail());
    }
}

function* uploadAvatarSaga(action) {
    try {
        const data = yield call(uploadAvatarApi, action.payload);
        if (data.status === 0) {
            toast.success(data?.result?.message);
            yield put(uploadAvatarSuccess());
        } else {
            toast.error(data?.result?.message);
        }
    } catch (e) {
        toast.error(appconstant.serverError);
    }
}
function* activeMainAdminSaga(action) {
    try {
        const data = yield call(activeMainAdminApi, action.payload);
        if (data.status === 0) {
            toast.success(data?.result?.message);
            yield put(activeMainAdminSuccess());
        } else {
            toast.error(data?.result?.message);     
}
    } catch (e) {
        toast.error(appconstant.serverError);
    }
}

function* deleteMainAdminSaga(action) {
    try {
        const data = yield call(deleteMainAdminApi, action.payload);
        if (data.status === 0) {
            toast.success(data?.result?.message);
            yield put(deleteMainAdminSuccess());
        } else {
            toast.error(data?.result?.message);
        }
    } catch (e) {
        toast.error(appconstant.serverError);
    }
}

function* editAdminSaga(action) {
    try {
        const data = yield call(editAdminApi, action.payload);
        if (data.status === 0) {
            toast.success(data?.result?.message);
            yield put(editAdminSuccess());
        } else {
            toast.error(data?.result?.message);
        }
    } catch (e) {
        toast.error(appconstant.serverError);
    }
}

export default function* rootSettingSaga() {
    yield takeLatest(createSubAdminLoad.type, createSubAdminSaga);
    yield takeLatest(createSubAdminListLoad.type, createSubAdminListSaga);
    yield takeLatest(getAccessListLoad.type, getAccessListSaga);
    yield takeLatest(uploadAvatarLoad.type, uploadAvatarSaga);
    yield takeLatest(activeMainAdminLoad.type, activeMainAdminSaga);
    yield takeLatest(deleteMainAdminLoad.type, deleteMainAdminSaga);
    yield takeLatest(editAdminLoad.type, editAdminSaga);

}
